import React, {useState, useEffect, useRef} from 'react'
import { Input, InputNumber, Form, Spin } from 'antd'

import './float.scss'
import { SpinnerIco } from "../../../modules/CustomIcons";
import { removeEmojiCodes } from '../../services/helper'
import { useTranslation } from 'react-i18next';


const InputField = (props: any) => {
  const {t} = useTranslation()
  const input_type=props.type || 'text';
  const input_name=props.name || 'input_';
  const input_id=`input_${input_name}`;

  const [focus, setFocus] = useState(false)
  const [value, setValue] = useState(props.value || '');
  const [maxLength, setMaxLength] = useState<number>(props.maxLength || 140);
  const [symbolCount, setSymbolCount] = useState<number>(maxLength);
  const [maxRows, setMaxRows] = useState<any>(5);
  const [visibleAutoComplete, setVisibleAutoComplete] = useState(false)
  const [disabled, setDisabled] = useState<boolean>(props.disabled || false)
  const [readOnly, setReadOnly] = useState<boolean>(props.readOnly || false)
  const { label } = props;
  const inputRefLocal = useRef<Input>(null)
  const [showMessage, setShowMessage] = useState<boolean>(props.showMessage || false)
  const [hasLoading, setHasLoading] = useState<boolean>(props.hasLoading || false)

  const updateValue = (get_value : string) => {
    if(props.account) {
      get_value = get_value?.replaceAll(" ", "")
    }
    let value_1 = props.allowLatin ? get_value?.replaceAll(/[а-яА-ЯЁё]+/g, '')?.replaceAll(/[~!@«»№#&;$%^*\=\{\}\[\]_<>«»“”\\\|?\/]/gi, '')
        : (props.allowRusUpper ? get_value?.replaceAll(/[a-zA-ZЁёğöəİışçĞÖƏŞÇÜü]+/g, '')?.replaceAll(/[~!@«»№#&;$%^*\=\{\}\[\]_<>«»“”\\\|?\/]/gi, '')
            : (props.onlyNumber ? get_value?.replaceAll(/[^0-9]+/g, '')
                : (props.allowLatinNumber ? get_value?.replaceAll(/[а-яА-ЯЁёğöəİışçĞÖƏŞÇÜü]+/g, '')?.replaceAll(/[~!@«»№#&;$%^*\=\{\}\[\]_<>«»“”\\\|?\/]/gi, '')
                    : (props.onlyNumberAndEng ? get_value?.replaceAll(/[^a-zA-Z0-9]+/g, '')
                        :(props.onlyNumberAndUpEng ? get_value?.replaceAll(/[^A-Z0-9]+/g, '')
                            :(props.onlyNumberandLowEng ? get_value?.replaceAll(/[^a-z0-9]+/g,'')
                               :(props.onlyNumberandSomesymbol ? get_value?.replaceAll(/[^0-9.-]+/g,'')
                                : props.allowLatinWithSomeSymbols ? get_value?.replaceAll(/[а-яА-ЯЁё]+/g, '')?.replaceAll(/[!«»№#&;$%^*\=\{\}\[\]_<>«»“”\\\|?\/]/gi, '') :
                                                                    (props.somesymbolsOnly ? get_value?.replaceAll(/[!@«»№#&;$%^*\=\{\}\[\]_<>«»“”\\|?]/gi, '') :  get_value?.replaceAll(/[!@«»№#&;$%^*\=\{\}\[\]_<>«»“”\\\|?\/]/gi, '')
                                                                    )
                               )
                            )
                        )
                    )
                )
            )
        );

    let value_ = props.allowAllSymboll || props.email ? get_value : value_1;
if(props.dontAllowminus){
  value_ = value_.replaceAll('-','')
}
    if(props.onlyNumberandSomesymbol && value_ !== undefined && value_.length > 1){
      if(value_.length===10){
        const value1 = value_+'-'
        value_ = value1
      }
    }



    if( props.email && value_ !== undefined && value_.length > 1){

      if(value_.includes('@')){
        const newemail = value_.split("@")

        const localpart = newemail[0]?.replaceAll(/[^\^A-Za-z0-9.!@#$%&*_+\/=[\]{}`~'"?\\|-]/g,'')

        const domain = newemail[1]?.replaceAll(/[^A-Za-z0-9.-]+/g,'')

        const value1= localpart+'@'+domain
        value_=value1

      }else{

          value_ =value_.replaceAll(/[^\^A-Za-z0-9.!@#$%&*_+\/=[\]{}`~'"?\\|-]/g,'')
      }
    }

    if (props.startLetterOnly && value_ !== undefined && value_.length === 1) {
      if (!(/[a-zA-Z0-9]/).test(value_?.substring(0, 1))) {
        value_ = ""
      }
    } else if (props.startLetterOnly && value_ !== undefined && value_.length > 1) {
      if (!(/[0-9]/).test(value_?.substring(value_.length - 1, value_.length))) {
        value_ = value_.substring(0, value_.length - 1)
      }
    }

    if (value_?.replaceAll(/\s/g, '').length === 0) {
      value_ = "";
    }

    if(props.upper && value_ !== undefined && value_ !== null) {
      value_ = value_?.toString().toUpperCase()
    }

    if (props.form) {
      props.form.setFieldsValue(
          {
            [input_name]: removeEmojiCodes(value_)
          }
      );
    }

  }

  useEffect(() => {
    if (props.value){
      updateValue(props.value);
    }

    if (props.maxLength){
      setSymbolCount(props.maxLength)
      setMaxLength(props.maxLength)
    }

    setDisabled(old_data => props.disabled)
    setReadOnly(old_data => props.readOnly)

    //setShowMessage(old_data => props.showMessage);
    /*
    setHasLoading(old_data => props.hasLoading);*/

  }, [props.value, props.maxLength, props.disabled, props.readOnly, props.mask, props.placeholder, props.notValid, props.showMessage/*, props.hasLoading*/]);

  const hideAutoComplete = (row) => {
    props.filterRowClick(row);

    setVisibleAutoComplete(old_status => false);

  }

  const labelClass = focus || props.value ? 'label label-float' : 'label';

  const handleInputChange = (e) => {
    if (props.handleInputChange){
      props.handleInputChange(e);
    }

    if (props.onChange){
      props.onChange(e);
    }

    if (props.autoComplete){
      setVisibleAutoComplete(old_status => props?.form.getFieldValue(input_name)?.length >= 2);
    }

    if (props.isNumeric){

      const value = e.target?.value;
      const reg = /^-?\d*(\.\d*)?$/;

      if ( (!isNaN(value) && reg.test(value)) || value === '' || value === '-' ) {

        updateValue(value);
      }

    } else{
      updateValue(e.target.value);
    }

  };

  const handleInputKeyUp = (e) => {
    let value=e.target.value;
    updateValue(value);

    if(props.onKeyUp){
      props.onKeyUp(e);
    }

    updateCounter();

  }

  const updateCounter = () => {

    if (props.showCount){
      let value_length=props.form.getFieldValue(props.name)?.length,
          calc_row=value_length >= 210 ? 100 : 5,
          symbol_count=maxLength - value_length;

      setSymbolCount(old_value => !isNaN(symbol_count) ? symbol_count : maxLength);

      setMaxRows(old_value => calc_row);


    }
  }
  useEffect(() => {
    if (props.showCount) {
      if(symbolCount === maxLength) {
        let value_length = props.form.getFieldValue(props.name)?.length,
            calc_row = value_length >= 210 ? 100 : 5,
            symbol_count = maxLength - value_length;
        setSymbolCount(old_value => !isNaN(symbol_count) ? symbol_count : maxLength);
        setMaxRows(old_value => calc_row);
      }
    }
  }, []);
  const onBlur = (e) => {

    if (props.onBlur){
      props.onBlur(e);
    }

    const { value} = e.target;
    let valueTemp = value;



    if (props.isNumeric){
      const {onBlur, onChange } = e;

      if (value.charAt(value.length - 1) === '.' ||  value === '-') {
        valueTemp = value.slice(0, -1);
      }

      handleInputChange(valueTemp?.replaceAll(/0*(\d+)/g, '$1'));
    }


  };

  const onKeyPress = (e) => {

    if (props.onKeyPress){
      props.onKeyPress();
    }

    const value=e.target.value;
    const key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    const regex = new RegExp(/^[^!-\\/:-@\\[-`{-~]+$/);
    const is_russian=/[а-яА-ЯЁё]/.test(value);
    const letterNumber = /[A-Z0-9]+$/i;
    const isUpperCase = (string) => /^[A-Z]*$/.test(string)
    const isOnlyEnglish = /[^a-zA-Z0-9]/g;

    if (props.allowCyrillic && !/[а-яА-ЯЁё]/.test(value)){
      e.preventDefault();
      return false;
    }


    if (props.onlyLetter){

      if (!props.allowAllSymboll && (!regex.test(key) && !isUpperCase(key)) || is_russian ) {

        e.preventDefault();
        return false;

      }
    }

    if(props?.onlyEnglishAndNumber){
      if (e.key.match(isOnlyEnglish)) {

        e.preventDefault();
        return false;

      }
    }

    if (props.onlyLetterAndNumber){

      if (!e.key.match(letterNumber) || is_russian ) {

        e.preventDefault();
        return false;

      }

    }

    // if (maxLength && value.length > maxLength-1){
    //   console.log('isledi')
    //   e.preventDefault();
    // }

    if (props.isNumeric){
      let regex = /[0-9]|\./;

      if (e.which==101 || !regex.test(key)){
        e.preventDefault();
      }

    }


    updateValue(e.target.value);

  }

  const onPaste = async (e:any) => {
      if(!props.readOnly && !props.disabled) {
        var pastedText = e.clipboardData.getData('text');
        pastedText = pastedText?.toString()?.trim();
        var pastedTextLength = pastedText.length;
        var maxLength = e.target.maxLength;
        if (props.onPaste) {
          await props.onPaste(pastedText);
        }
        if (props.autoComplete){
          setVisibleAutoComplete(old_status => pastedText?.length >= 2);
        }

        if ((pastedTextLength + e.target.value.length) > maxLength) {
          e.preventDefault();
        } else {
          //var filteredText = pastedText.replace(/[^a-zA-Z0-9]/g, '');
          updateValue(pastedText)
        }
        if (!props.modal) {
          e.preventDefault()
        }
      }
  }

  let validate_message=props.message || '';

  if (props.required && !props.message){
    validate_message=t("newTransfer.requiredField");

  }

  if (props.showMessage){
    validate_message='';
  }

  let divClass='custom_input_component ';

  if (props.readOnly){
    divClass+=' input_readonly  '
  }

  const handleWheel = (event) => {
    // console.log(props.inputRef)
    // console.log("handleWheel")
    if (event.currentTarget === document.activeElement) {
      // console.log("handleWheel")
      // event.preventDefault();
      // event.preventDefault();
      // inputRefLocal.current.scrollLeft += event.deltaY;
    }
  };

  const onReset = () => {

    if (props.staticValue){
      updateValue(props.value);
    }


    updateCounter();

    setShowMessage(old_value => false);

    let current_input=document.querySelector(`#${input_name}`);

    if (current_input?.classList.contains('isReadOnly')){
      setReadOnly(old_data => true)
    }

    if (current_input?.classList.contains('isDisabled')){
      setDisabled(old_data => true)
    }

  }

  return (
    <div className={divClass} key={props.name}>
      <Form.Item
        name={input_name}
        label={props.labelItem}
        labelCol={props.labelCol}
        labelAlign={props.labelAlign}
        // labelWrap={props.labelWrap}
        wrapperCol={props.wrapperCol}
        className={`${props?.className} input-field input_all_div input_all_div_error`}
        validateTrigger={['onChange', 'onBlur']}
        rules={[
            {
              required: props.required || false,
              message : validate_message,
              /*pattern: props.onlyEngLetter ? new RegExp(/[A-Z]+$/g) : undefined,*/
            },
            ({ getFieldValue }) => ({
              validator(_, value) {

                if (props.notValid && value){
                  return Promise.reject(new Error(props.message));
                }else{
                  return Promise.resolve();
                }
              },
            })
        ]}
        onReset={onReset}
        shouldUpdate={(prevValues, curValues) => {

          if (prevValues[input_name]!==curValues[input_name]){
            setDisabled(old_value => false);
          }

          return true;
        }}
      >

        <Input
            className={props.className}
            readOnly={readOnly}
            name={input_name}
            ref={props.inputRef !== undefined ? props.inputRef : inputRefLocal}
            maxLength={maxLength}
            /*autosize={{ minRows: 3, maxRows: maxRows }}*/
            placeholder={props.placeholder}
            // autoComplete="off"
            autoComplete="new-password" 
            prefix={props.prefix || false}
            suffix={props.suffix || false}
            value={value}
            addonBefore={props.addonBefore || false}
            allowClear={props.allowClear || false}
            // initialValues={props.defaultValue || ''}
            defaultValue={props.defaultValue}
            size = {props.size}
            onChange={handleInputChange}
            onKeyUp={handleInputKeyUp}
            onBlur={onBlur}
            onKeyPress={onKeyPress}
            onPaste={onPaste}
            onWheel={handleWheel}
            /*value={value}*/
            mask={props.mask}
            disabled={disabled}
            style={props.style}
            type={input_type}
            /*id={input_id}*/
        />

      </Form.Item>

      {
         label && <label className={props.type == 'phoneNumber' ? 'label label-float phone-number' : labelClass}>{label}</label>
      }

      {
          props.showCount && <div  className={'show_input_counter'}><span className={'show_symbol_count'}>{symbolCount < 0 ? 0 : symbolCount}</span>/{maxLength}</div>
      }

      {
          props.hasLoading && <Spin className={`${props.customClass} custom_spin`} indicator={<SpinnerIco />} />
      }

      {
          props.showMessage  && <span className={'form_error_span'} >{props.message}</span>
      }

      {
          props.autoComplete && props?.form.getFieldValue(input_name)?.length >= 2 && props.options?.length>0 && visibleAutoComplete &&
          <div className={'full flex direction_column autocomplete_box '} >

            {
              props.options?.length == 0 && props?.form.getFieldValue(input_name)?.length >= 2 ? <p className={'full flex justify_center code_not_found'} >{t("notification.notFoundInfo")}</p> :

                  <ul className={'full flex direction_column autocomplete_list scroll_y'} >
                    {
                      props.options?.map((row, index) => {
                        return (
                            <li onClick={() => hideAutoComplete(row) }  key={`filter_item_${index}`} >
                              { row.CODE ? row.CODE : row.BIC_CODE ??  row.MAIN_BIC ?? row.orgcode ?? row.code }
                            </li>
                        )
                      })
                    }
                  </ul>
            }

          </div>
      }

    </div>
  )
}

export default InputField
